// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3APrg","selects":"Documents_selects__1luK7"};